import "@preline/collapse";

/**
 * Initializes all Preline “collapse” components once the DOM is ready.
 * @returns {void}
 */
const init = () => {
  window.HSStaticMethods?.autoInit?.(["collapse"]);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}
